import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'academic-cap-icon',
  templateUrl: './academic-cap-icon.component.html',
  styles: [':host { line-height: 0; }'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AcademicCapIconComponent {}
